module.exports = __webpack_public_path__ + "img/key-02.0117d6b7.svg";